import React from "react";

export const offline = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 141 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5053 28.7084C22.7657 25.2989 18.5908 23.9071 15.1812 25.5771C10.7278 27.8037 6.41367 31.4919 3.14325 34.5536C0.290334 37.1282 0.151098 41.5814 2.72568 44.3647C4.11735 45.8259 5.9961 46.5914 7.87485 46.5914C9.54485 46.5914 11.2149 45.965 12.6065 44.7821C13.9982 43.5296 18.1732 39.6332 21.4436 38.0327C24.8532 36.2932 26.2449 32.118 24.5749 28.7084H24.5053Z"
        fill="currentColor"
      />
      <path
        d="M137.717 33.3007C119.138 16.8791 95.48 7.83338 71.1258 7.83338C59.6446 7.83338 48.4417 9.78186 37.7258 13.6089C37.5171 13.6785 37.3083 13.8873 37.0996 14.0264L26.8708 3.10179C24.2267 0.318455 19.843 0.109775 17.0596 2.75394C14.2763 5.39811 14.1371 9.78172 16.7117 12.5651L114.128 116.94C115.52 118.401 117.329 119.167 119.208 119.167C120.878 119.167 122.617 118.54 123.94 117.288C126.723 114.644 126.862 110.26 124.287 107.477L72.935 52.4362C88.3129 52.9232 102.647 59.3945 113.572 70.8757C114.963 72.337 116.772 73.0328 118.582 73.0328C120.321 73.0328 122.061 72.4073 123.383 71.0852C126.166 68.441 126.305 64.0566 123.661 61.2732C109.675 46.5217 90.9571 38.4503 71.1258 38.4503C67.6467 38.4503 64.1675 38.7285 60.7579 39.2155C60.7579 39.2155 60.6883 39.2155 60.6187 39.2155L47.4675 25.09C55.1217 22.8633 63.0542 21.6805 71.1258 21.6805C92.0704 21.6805 112.458 29.474 128.532 43.669C129.854 44.8519 131.524 45.4086 133.125 45.4086C135.073 45.4086 136.952 44.643 138.343 43.0426C140.918 40.1896 140.64 35.7365 137.717 33.2315V33.3007Z"
        fill="currentColor"
      />
      <path
        d="M44.615 50.6966C42.6666 47.3566 38.4221 46.2433 35.0821 48.1916C29.3763 51.462 24.1575 55.5674 19.4954 60.2991C16.7816 63.0128 16.8512 67.4661 19.4954 70.1103C20.8871 71.4324 22.6266 72.1282 24.3662 72.1282C26.1058 72.1282 27.9846 71.4324 29.3067 70.0407C33.1338 66.1441 37.3783 62.8737 41.9708 60.1599C45.3108 58.2116 46.4241 53.967 44.4758 50.627L44.615 50.6966Z"
        fill="currentColor"
      />
      <path
        d="M65.9072 74.9812C64.7939 71.2932 60.8972 69.2753 57.2093 70.3887C49.9727 72.6153 42.8752 79.2953 39.3264 83.0528C36.6822 85.8362 36.7518 90.2192 39.6047 92.8634C40.9268 94.1159 42.6664 94.8124 44.406 94.8124C46.2152 94.8124 48.0939 94.1166 49.416 92.6553C53.7302 88.1324 58.3922 84.6532 61.3147 83.7487C65.0027 82.6353 67.0206 78.7387 65.9072 75.0507V74.9812Z"
        fill="currentColor"
      />
      <path
        d="M70.4999 118.888C75.304 118.888 79.1978 114.994 79.1978 110.19C79.1978 105.387 75.304 101.492 70.4999 101.492C65.6959 101.492 61.802 105.387 61.802 110.19C61.802 114.994 65.6959 118.888 70.4999 118.888Z"
        fill="currentColor"
      />
    </svg>
  );
};
